import { createApiMutation, createApiQuery } from '@/features/api'

import type { IUnit, IUnitMutationData } from './type'

export const unitList = createApiQuery<{
	result: { units: IUnit[] }
}>('/unit/list')

export const unitDetail = createApiQuery<{
	params: { id: string }
	result: { unit: IUnit }
}>('/unit/detail')

export const unitCreate = createApiMutation<{
	body: IUnitMutationData
}>('/unit/create', { method: 'post' })

export const unitUpdate = createApiMutation<{
	body: IUnitMutationData & { id: string }
}>('/unit/update', { method: 'put' })
